import React, { useState, useEffect } from 'react';

const BlogPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate fetching data with a delay
    const mockPosts = [
      {
        id: '1',
        title: `The Art of Procrastination (and How to Beat It)`,
        description: `Feeling stuck? Learn why we procrastinate and practical strategies to overcome it, boosting your productivity and peace of mind.`,
        slug: 'art-of-procrastination',
        createdAt: '2025-07-20T10:00:00Z',
        author: 'Somo Team',
      },
      {
        id: '2',
        title: `Burnout Busters: Simple Habits for Student Well-being`,
        description: `Student life can be intense. Discover easy-to-implement habits that help prevent burnout and maintain your mental and physical health.`,
        slug: 'burnout-busters',
        createdAt: '2025-07-18T14:30:00Z',
        author: 'Dr. Wellness',
      },
      {
        id: '3',
        title: `Mastering Exam Anxiety: A Student's Guide to Calm`,
        description: `Exams can be daunting, but anxiety doesn't have to control you. This guide offers techniques to manage stress and perform your best.`,
        slug: 'mastering-exam-anxiety',
        createdAt: '2025-07-15T09:15:00Z',
        author: 'Prof. Insight',
      },
      {
        id: '4',
        title: `The Power of Active Recall: Study Smarter, Not Harder`,
        description: `Unlock your learning potential with active recall. This method helps you remember more by actively retrieving information, making study sessions more effective.`,
        slug: 'active-recall',
        createdAt: '2025-07-12T11:45:00Z',
        author: 'Somo Team',
      },
      {
        id: '5',
        title: `Navigating Group Projects: Collaboration for Success`,
        description: `Group projects can be challenging. Learn strategies for effective communication, conflict resolution, and fair contribution to ensure team success.`,
        slug: 'group-projects',
        createdAt: '2025-07-10T16:00:00Z',
        author: 'Teamwork Guru',
      },
    ];

    setTimeout(() => {
      setPosts(mockPosts);
      setLoading(false);
    }, 1000); // Simulate 1 second loading time
  }, []);

  if (loading) {
    return <div className="flex justify-center items-center h-screen text-lg">Loading blog posts...</div>;
  }

  if (posts.length === 0) {
    return <div className="flex justify-center items-center h-screen text-lg">No blog posts found.</div>;
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-4xl font-bold mb-8 text-center">SOMO Blog</h1>
      <div className="flex overflow-x-auto space-x-6 pb-4 scrollbar-hide">
        {posts.map((post) => (
          <div key={post.id} className="flex-none w-80 bg-white rounded-lg shadow-md overflow-hidden transform transition duration-300 hover:scale-105">
            <div className="p-6">
              <h2 className="text-2xl font-semibold text-gray-800 mb-2 truncate">{post.title}</h2>
              <p className="text-gray-600 text-sm mb-4 line-clamp-3">{post.description}</p>
              <p className="text-gray-500 text-xs">By {post.author} on {new Date(post.createdAt).toLocaleDateString()}</p>
              {/* Add a link to a detailed post page if you implement one */}
              <button className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition duration-300">Read More</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogPage;
